import { useState, useMemo, useCallback } from "react";

import { useDispatch } from "react-redux";

import "./LoginPanel.css";

import LoginForm from "./LoginForm";
import ForgotPasswordForm from "./ForgotPasswordForm";
import CheckEmailAccountRecovery from "./CheckEmailAccountRecovery";
import { makeLoginRequest } from "API/Auth";
import { authSuccess } from "../../../../../Store/features/authSlice";

const LOGIN_PANEL_STATES = {
  DEFAULT: "default",
  FORGOT_PASSWORD: "forgot_password",
  CHECK_EMAIL: "check_email",
  LOADING: "loading",
};

const LoginPanel = (props) => {
  const dispatch = useDispatch();
  const [loginPanelState, setLoginPanelState] = useState(
    LOGIN_PANEL_STATES.DEFAULT
  );

  const handleSendLoginRequst = useCallback(
    async (email, password) => {
      const response = await makeLoginRequest(dispatch, email, password);
      dispatch(authSuccess(response.token));
    },
    [dispatch]
  );

  const handleForgotPasswordClick = useCallback(() => {
    setLoginPanelState(LOGIN_PANEL_STATES.FORGOT_PASSWORD);
  }, [setLoginPanelState]);

  const handleClickSubmitAccountRecovery = useCallback(() => {
    setLoginPanelState(LOGIN_PANEL_STATES.CHECK_EMAIL);
  }, [setLoginPanelState]);
  return (
    <div className="login-panel-container">
      {loginPanelState === LOGIN_PANEL_STATES.DEFAULT ? (
        <LoginForm
          onForgotPasswordClick={handleForgotPasswordClick}
          onLogin={handleSendLoginRequst}
        />
      ) : null}
      {loginPanelState === LOGIN_PANEL_STATES.FORGOT_PASSWORD ? (
        <ForgotPasswordForm
          onClickSubmitAccountRecovery={handleClickSubmitAccountRecovery}
        />
      ) : null}
      {loginPanelState === LOGIN_PANEL_STATES.CHECK_EMAIL ? (
        <CheckEmailAccountRecovery />
      ) : null}
    </div>
  );
};

export default LoginPanel;
